import { useEffect, useState } from "react";
import { History, Plus } from "lucide-react";
import api from "../lib/api";

export default function FavoriteItems({ category, onPick, existing }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/me/items/suggestions${category ? `?category=${encodeURIComponent(category)}` : ""}`)
      .then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [category]);
  const used = new Set((existing || []).map(i => `${(i.name || "").toLowerCase()}|${(i.notes || "").toLowerCase()}`));
  const list = items.filter(i => !used.has(`${i.name.toLowerCase()}|${i.notes.toLowerCase()}`));
  if (list.length === 0) return null;
  return (
    <div className="mt-4 rounded-2xl border border-slate-200 bg-slate-50/60 p-3" data-testid="favorite-items">
      <div className="text-[11px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5"><History className="w-3.5 h-3.5" /> I tuoi articoli già descritti · tocca per aggiungere</div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {list.map((it, idx) => (
          <button key={`${it.name}|${it.notes}|${it.unit}`} type="button" onClick={() => onPick(it)}
            className="group inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-3 py-1.5 text-xs text-slate-800 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-colors max-w-full"
            title={it.notes || it.name} data-testid={`favorite-item-${idx}`}>
            <Plus className="w-3 h-3 shrink-0" />
            <span className="font-semibold truncate max-w-[180px]">{it.name}</span>
            {it.notes && <span className="truncate max-w-[220px] text-slate-500 group-hover:text-slate-300">· {it.notes}</span>}
            <span className="font-mono text-[10px] text-slate-400 group-hover:text-slate-300">{it.unit}</span>
            {it.uses > 1 && <span className="rounded-full bg-amber-100 text-amber-800 group-hover:bg-amber-400 group-hover:text-slate-900 px-1.5 text-[10px] font-bold">×{it.uses}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
